// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import {
  brandSpecificTopRatedBGColor,
  brandSpecificBestSellerBGColor,
  brandSpecificTopRatedColor,
} from '@tcp/core/src/utils/utils.web';
import { TOP_RATED } from '@tcp/core/src/constants/badge.constants';

const getBadgeStyle = css`
  box-sizing: border-box;
  text-decoration: uppercase;
  margin-right: 8px;
  border-radius: 3px;

  .underline {
    text-decoration: underline;
  }

  .top-badge {
    max-width: 136px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 14px;
  }

  .top-badge-label {
    text-transform: uppercase;
  }

  @media only screen and (min-width: 1200px) {
    .top-badge {
      max-width: unset;
    }
  }
`;

const BadgeContainer = styled.div`
  ${getBadgeStyle}
  background: ${(props) =>
    props.type === TOP_RATED
      ? brandSpecificTopRatedBGColor(props)
      : brandSpecificBestSellerBGColor(props)};
  padding: ${(props) => (props.type === TOP_RATED ? '1px 8px' : '1px 4px')};
  .top-badge {
    color: ${(props) =>
      props.type === TOP_RATED ? brandSpecificTopRatedColor(props) : props.theme.colors.WHITE};
  }
`;

export default BadgeContainer;
